class ApiErrors extends Error {
  constructor(status, message) {
    super(message);
    this.status = status;
  }
}

const defaultHeaders = (token) => ({
  "content-type": "application/json",
  ...(token && { _sid: token }),
});

const parseResponse = (response, autoParse) => {
  const textTypes = ["text/plain", "text/html", "text/xml"];
  const contentType = response.headers.get("content-type");

  if (autoParse) {
    if (contentType.includes("application/json")) return response.json();
    else if (textTypes.find(contentType)) return response.text();
    else if (
      contentType.includes("image/") ||
      contentType.includes("audio/") ||
      contentType.includes("video/")
    )
      return response.blob();
  } else return response;
};

const buildPayload = ({
  method = "",
  body = null,
  signal = null,
  headers = null,
  credentials = "include",
} = {}) => {
  const payload = { credentials };

  if (method) payload.method = method;
  if (body) payload.body = JSON.stringify(body);
  if (signal) payload.signal = signal;
  if (headers) payload.headers = headers;

  return payload;
};

const fetchHelpers = {
  ApiErrors,
  defaultHeaders,
  parseResponse,
  buildPayload,
};

export default fetchHelpers;
